module.exports = __webpack_public_path__ + "static/media/ig-audio.53846606.jpeg";